import React, { FC } from 'react'
import classNames from 'classnames'
import { getImage } from '../../../app/utlis/imageConstants'
import DynamicSVG from '../../atoms/DynamicSvg/DynamicSvg'

interface ERPIdeaProjectsProps {
    erpSoftwareData: any
}

const ERPIdeaProjects: FC<ERPIdeaProjectsProps> = ({ erpSoftwareData }) => {
    return (
        <div className='flex flex-col gap-6 md:gap-12 pt-6 md:pt-12 bg-darkGreyPrimary justify-center items-center px-4 md:px-0'>
            {erpSoftwareData.ERPSoftwareIdeaProjectsData.map((projects: any, index:number) => {
                 let img = getImage(projects.image ?? "") ?? "";
                return (
                    <div className='bg-blackDark p-4 md:p-8 w-full md:w-[80%]'>
                        <div className={`flex flex-col justify-center md:flex-row ${index % 2 === 0 ? 'md:flex-row-reverse' : 'md:flex-row'} gap-6 md:gap-10 bg-blackDark`}>
                            <div className='bg-darkGreyPrimary w-full md:w-2/5 h-48 md:h-auto'>
                            <DynamicSVG size='w-full h-full'>{img}</DynamicSVG></div>
                            <div className={classNames('flex flex-col w-full md:w-2/4', `flex-${projects.row}`)}>
                                <div className={classNames('font-semibold text-2xl md:text-4xl', `text-${projects.textColor}`)} >{projects.title}</div>
                                <div className={classNames('text-greyQuaternary text-base md:text-lg pt-1 pb-6 md:pb-10', `text-${projects.text}`)}>{projects.subtitle}</div>
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 justify-between group`}>
                                    {projects.steps.map((step: any) => {
                                        return (
                                            <div className={`bg-blackDark p-4 rounded-lg font-bold text-lg md:text-xl relative overflow-hidden border-2 border-[#292929] hover:border-${projects.textColor}`}>{step.title}</div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default ERPIdeaProjects
